import React, { useState } from "react";
import { firestore } from "../shared/FirebaseConfig";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import "../shared/Modal.css";

const InviteModal = ({ onClose, user, classData, schoolId }) => {
  const [invitedEmail, setInvitedEmail] = useState("");
  const [teacherRole, setTeacherRole] = useState(""); // New state for teacher role
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleInviteSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!invitedEmail.trim()) {
      setError("Enter the teacher's email.");
      return;
    }
    if (!teacherRole) {
      setError("Pick a role for the teacher.");
      return;
    }

    // schoolId is REQUIRED: the invitations create rule gates on
    // sameSchool(request.resource.data.schoolId), so an invite written
    // without it is denied ("Missing or insufficient permissions").
    const inviteSchoolId = schoolId || classData.schoolId;
    if (!inviteSchoolId) {
      setError("You need to join a school before inviting teachers.");
      return;
    }

    setSaving(true);
    try {
      const invitationsCollectionRef = collection(firestore, "invitations");
      const newInvitation = {
        invitedByEmail: user.email,
        invitedToEmail: invitedEmail.trim().toLowerCase(),
        classId: classData.id,
        // Denormalize the class name onto the invitation so the invitee sees it
        // even when they can't yet READ the class doc (they're not on it, and
        // may not be same-school) — otherwise it renders as "Unknown Class".
        className: classData.className || "",
        schoolId: inviteSchoolId,
        teacherRole: teacherRole,
        createdAt: serverTimestamp(),
        status: "pending",
      };

      await addDoc(invitationsCollectionRef, newInvitation);
      onClose(); // Close the modal after successful invitation
    } catch (error) {
      console.error("Error inviting teacher:", error);
      setError("Couldn't send the invitation. Please try again.");
      setSaving(false);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content invite-modal">
        <h2>Invite Teacher to Join {classData.className}</h2>{" "}
        {/* Display class name */}
        <div className="invite-field">
          <label htmlFor="invite-email">Email</label>
          <input
            id="invite-email"
            type="email"
            placeholder="teacher@school.org"
            value={invitedEmail}
            onChange={(e) => setInvitedEmail(e.target.value)}
          />
        </div>
        {/* Dropdown for teacher role */}
        <div className="invite-field">
          <label htmlFor="invite-role">Teacher Role</label>
          <select
            id="invite-role"
            className="teacher-role-dropdown"
            value={teacherRole}
            onChange={(e) => setTeacherRole(e.target.value)}
          >
            <option value="">Select Role</option>
            <option value="co-teacher">Co-Teacher</option>
            <option value="other">Other</option>
          </select>
        </div>
        {error && <p className="invite-error">{error}</p>}
        <div className="invite-actions">
          <button
            className="btn-primary"
            onClick={handleInviteSubmit}
            disabled={saving}
          >
            {saving ? "Sending…" : "Invite"}
          </button>
          <button
            className="btn-secondary"
            onClick={handleClose}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteModal;
